import React from "react";

/**
 * Wraps a settings panel whose backend isn't built yet. Renders the
 * child component disabled with a "Coming soon" badge so the admin
 * doesn't 404 on Save.
 *
 * Usage:
 *   <ComingSoonOverlay note="Business hours config arrives in Q3">
 *     <BusinessHoursCalendar />
 *   </ComingSoonOverlay>
 */
export default function ComingSoonOverlay({ children, note = "" }) {
  return (
    <div className="relative">
      <div
        aria-disabled="true"
        style={{
          opacity: 0.45,
          pointerEvents: "none",
          filter: "saturate(0.7)",
        }}
      >
        {children}
      </div>
      <div
        className="absolute top-3 right-3 z-10 px-3 py-1 rounded-full
                   text-[10px] font-medium uppercase tracking-widest
                   bg-yellow-400/15 border border-yellow-400/40 text-yellow-300
                   shadow-[0_0_12px_rgba(250,204,21,0.25)]"
        title={note || "Coming soon"}
      >
        Coming soon
      </div>
    </div>
  );
}
